<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mt-5">
                <v-row class="px-5">
                  <v-col
                    v-for="category in categories"
                    :key="category.id"
                    cols="12"
                  >
                    <v-btn
                      @click="goCategoryDetail(category)"
                      style="
                        background-color: #102a62;
                        color: white;
                        padding: 50px;
                        font-size: large;
                      "
                      block
                    >
                      {{ category.Name }}
                      <v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import AcademyFilterButton from '../../components/Academy/AcademyFilterButton.vue';
import LoadingProgress from '../../components/General/LoadingProgress.vue';
import PostService from '@/services/PostService';
export default {
  data() {
    return {
      loadingSearch: false,
      loading: true,
      categories: [],
      searchTextModel: '',
      searchText: '',

      page: 0,
      pageSize: 50,
    };
  },
  components: {
    LoadingProgress,
    AcademyFilterButton,
  },
  mounted() {
    this.getVizgoCategories();
  },
  methods: {
    getVizgoCategories() {
      this.loading = true;
      PostService.getVizgoCategories()
        .then((response) => {
          const data = response.data || [];
          this.categories = data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goCategoryDetail(category) {
      this.$router.push({
        name: 'vizgoCategoryDetail',
        params: { id: category.Id },
      });
    },
  },
};
</script>

<style></style>
